export default "__VITE_PUBLIC_ASSET__74f6e56e__"